import { useEffect, useState } from 'react'
import { callApiAsync } from 'services/api/callAPIAsync'

const HealthCheck = () => {
    const [check, setCheck] = useState(null)

    useEffect(() => {
        async function healthCheck() {
            const { error } = await callApiAsync('healthCheck')
            if (error) {
                setCheck(false)
                return
            }
            setCheck(true)
        }

        healthCheck()
    }, [])

    if (check === null) return null

    return <div className="bg-secondary m-5 p-5 text-center">{check ? 'Working OK' : 'NOT WORKING'}</div>
}

export default HealthCheck
